const Variants = {
  /**
   * Create
   * @param {HTMLFormElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;
    this.subscribeToken = null;

    this.node.addEventListener('click', (e) => {
      if (e.target.className.indexOf('js-show-variant') >= 0) {
        this.openVariant(e.target);
      }

      if (e.target.className.indexOf('js-add-variant') >= 0) {
        this.openCreateVariant(e.target);
      }
    });

    this.node.addEventListener('change', (e) => {
      if (e.target.getAttribute('name').indexOf('primary_variant') >= 0) {
        this.changePrimaryVariant(e.target);
      }
    });
  },

  getRow(target) {
    const $row = $(target).parents('[data-variant-id]');

    return $row[0];
  },

  openVariant(target) {
    const row = this.getRow(target);
    window.PageOverlay.open(row.getAttribute('data-variant-url'));

    this.createOverlayCloseCallback();
  },

  createOverlayCloseCallback() {
    this.subscribeToken = window.pubsub.subscribe('po.close', (eventName, node) => {
      this.closeOverlay(node);
    });
  },

  closeOverlay() {
    this.reloadVariants();

    window.pubsub.unsubscribe(this.subscribeToken);
  },

  openCreateVariant(target) {
    window.PageOverlay.open(target.getAttribute('data-create-url'));

    this.createOverlayCloseCallback();
  },

  changePrimaryVariant(target) {
    window.axios.get(target.getAttribute('data-change-url'))
      .then(() => {
        window.toaster.show('Primaire variant is gewijzigd', 2500);
      })
      .catch(() => {
        window.toaster.show('Er ging iets mis bij het wisselen van de variant', 3000, 'danger');
      });
  },

  reloadVariants() {
    window.axios.get(this.node.getAttribute('data-variants-url'))
      .then((res) => {
        this.outputVariants(res.data);
      })
      .catch(() => {
        window.toaster.show('Er ging iets mis bij het ophalen van de varianten', 3000, 'danger');
      });
  },

  outputVariants(html) {
    const $variantsElement = $(html).find('[data-component="Variants"]');

    if ($variantsElement.length) {
      $(this.node).html($variantsElement.html());
    }
  },
};

export default Variants;
